var _defs, _path, _path2, _path3, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.26 60.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f0f1f2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.07,425.41A26.13,26.13,0,1,0,301,399.55a5,5,0,1,0-7.53,0,26.17,26.17,0,0,0-22.36,25.86h0Zm23.12-29.15a3,3,0,1,1,3,3,3,3,0,0,1-3-3h0Zm3,5a24.12,24.12,0,1,1-24.12,24.12,24.12,24.12,0,0,1,24.12-24.12h0Zm0,0",
    transform: "translate(-271.07 -391.24)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.2,446.51a21.11,21.11,0,1,0-21.11-21.11,21.11,21.11,0,0,0,21.11,21.11h0Zm0-40.2a19.1,19.1,0,1,1-19.1,19.1,19.1,19.1,0,0,1,19.1-19.1h0Zm0,0",
    transform: "translate(-271.07 -391.24)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.73,426.41L285.28,436a1,1,0,0,0,1.37,1.37l9.55-5.46v9.61a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V430.73l1.84-1.05,7.81,7.81a1,1,0,0,0,1.42,0h0a1,1,0,0,0,0-1.42l-7.81-7.81,1.05-1.84h9.75a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1h-8.61l5.46-9.55a1,1,0,0,0-1.37-1.37l-9.55,5.46v-9.61a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1v10.76l-1.84,1.05-7.81-7.81a1,1,0,0,0-1.42,0h0a1,1,0,0,0,0,1.42l7.81,7.81-1.05,1.84h-9.75a1,1,0,0,0-1,1h0a1,1,0,0,0,1,1h8.61Zm14.82-9.36-6.08,10.63-10.63,6.08,6.08-10.63Zm0,0",
    transform: "translate(-271.07 -391.24)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.9,
    y: 32.94,
    width: 2.46,
    height: 2.46,
    rx: 1.23,
    ry: 1.23
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.5c9ff1d2.svg";
export { ForwardRef as ReactComponent };